var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.66797C7.44248 1.66797 5.91992 2.12983 4.62489 2.99515C3.32985 3.86046 2.32049 5.09037 1.72445 6.52934C1.12841 7.96831 0.972461 9.5517 1.27632 11.0793C1.58018 12.6069 2.3302 14.0101 3.43154 15.1114C4.53288 16.2128 5.93607 16.9628 7.46367 17.2667C8.99127 17.5705 10.5747 17.4146 12.0136 16.8185C13.4526 16.2225 14.6825 15.2131 15.5478 13.9181C16.4131 12.623 16.875 11.1005 16.875 9.54297C16.8727 7.45511 16.0422 5.45344 14.5659 3.9771C13.0895 2.50076 11.0879 1.67032 9 1.66797ZM9 16.293C7.20979 16.293 5.4929 15.5818 4.22703 14.3159C2.96116 13.0501 2.25 11.3332 2.25 9.54297C2.25 7.75276 2.96116 6.03587 4.22703 4.77C5.4929 3.50413 7.20979 2.79297 9 2.79297V9.54297L13.7707 14.3138C13.145 14.9416 12.4015 15.4397 11.5828 15.7793C10.7641 16.119 9.88636 16.2935 9 16.293Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.76a931c42af6767a65cb298da03ebee2.svg";
export { ForwardRef as ReactComponent };